export default {
  // 通用
  'common.codeExample': '代码示例',
  'common.tryItYourself': '自己试试',
  'common.output': '输出结果',
  'common.explanation': '说明',
  'common.bestPractices': '最佳实践',
  'common.commonMistakes': '常见错误',
  'common.relatedFunctions': '相关函数',

  // MySQL时间戳页面
  'mysql.mainTitle': 'MySQL时间戳完整指南',
  'mysql.mainTitleSEO': 'MySQL时间戳教程 - UNIX_TIMESTAMP与FROM_UNIXTIME指南',
  'mysql.subtitle': '掌握MySQL时间戳函数、数据类型和时区处理',

  'mysql.intro': 'MySQL提供了强大的函数来处理Unix时间戳。本指南涵盖从基本时间戳函数到高级时区处理的所有内容。',

  // UNIX_TIMESTAMP()部分
  'mysql.unixTimestampTitle': 'UNIX_TIMESTAMP() 函数',
  'mysql.unixTimestampDesc': '将日期/日期时间转换为Unix时间戳（自1970-01-01 00:00:00 UTC以来的秒数）',
  'mysql.getCurrentTimestamp': '获取当前Unix时间戳',
  'mysql.convertDateToTimestamp': '将日期转换为时间戳',
  'mysql.example1': '返回当前Unix时间戳（秒）',
  'mysql.example2': '将特定日期时间转换为时间戳',

  // FROM_UNIXTIME()部分
  'mysql.fromUnixtimeTitle': 'FROM_UNIXTIME() 函数',
  'mysql.fromUnixtimeDesc': '将Unix时间戳转换为MySQL日期时间格式',
  'mysql.convertTimestampToDate': '将时间戳转换为日期时间',
  'mysql.formatTimestamp': '使用自定义模式格式化时间戳',

  // TIMESTAMP vs DATETIME
  'mysql.typesTitle': 'TIMESTAMP与DATETIME数据类型对比',
  'mysql.timestampType': 'TIMESTAMP类型',
  'mysql.timestampFeature1': '范围：1970-01-01 到 2038-01-19',
  'mysql.timestampFeature2': '以UTC存储，转换为本地时区',
  'mysql.timestampFeature3': '在INSERT/UPDATE时自动更新',
  'mysql.timestampFeature4': '使用4字节存储',

  'mysql.datetimeType': 'DATETIME类型',
  'mysql.datetimeFeature1': '范围：1000-01-01 到 9999-12-31',
  'mysql.datetimeFeature2': '按原样存储，无时区转换',
  'mysql.datetimeFeature3': '手动更新',
  'mysql.datetimeFeature4': '使用8字节存储',

  // 实战示例
  'mysql.practicalTitle': '实战SQL示例',
  'mysql.example.insert': '插入当前时间戳',
  'mysql.example.query': '按时间戳范围查询记录',
  'mysql.example.update': '更新时间戳列',
  'mysql.example.aggregation': '时间戳聚合',

  // 时区处理
  'mysql.timezoneTitle': 'MySQL时区处理',
  'mysql.timezoneDesc': 'MySQL以UTC存储TIMESTAMP值，并将其转换为连接时区',
  'mysql.setTimezone': '设置会话时区',
  'mysql.convertTimezone': '在时区之间转换',

  // 常见用例
  'mysql.useCasesTitle': '常见使用场景',
  'mysql.useCase1.title': '跟踪记录创建时间',
  'mysql.useCase1.desc': '使用 DEFAULT CURRENT_TIMESTAMP 自动设置创建时间',

  'mysql.useCase2.title': '跟踪最后更新时间',
  'mysql.useCase2.desc': '使用 ON UPDATE CURRENT_TIMESTAMP 自动更新修改时间',

  'mysql.useCase3.title': '按日期范围筛选',
  'mysql.useCase3.desc': '使用 UNIX_TIMESTAMP() 按时间戳范围筛选记录',

  'mysql.useCase4.title': '按时间段分组',
  'mysql.useCase4.desc': '使用 FROM_UNIXTIME() 配合 DATE_FORMAT() 对记录分组',

  // 性能优化提示
  'mysql.performanceTitle': '性能优化技巧',
  'mysql.perf1': '为WHERE子句中使用的时间戳列创建索引',
  'mysql.perf2': '对需要时区转换的列使用TIMESTAMP',
  'mysql.perf3': '对TIMESTAMP范围外的历史日期使用DATETIME',
  'mysql.perf4': '避免在WHERE子句中使用函数 - 使用索引列',

  // FAQ
  'mysql.faq.q1': 'MySQL中的2038年问题是什么？',
  'mysql.faq.a1': 'TIMESTAMP使用有符号32位整数，将在2038年1月19日溢出。对于2038年之后的日期使用DATETIME。',

  'mysql.faq.q2': '如何在MySQL中存储毫秒？',
  'mysql.faq.a2': '使用BIGINT存储毫秒级Unix时间戳，或使用DATETIME(3)存储带毫秒精度的日期时间。',

  'mysql.faq.q3': '应该使用TIMESTAMP还是DATETIME？',
  'mysql.faq.a3': '对需要时区感知的近期日期使用TIMESTAMP。对历史日期或不需要时区转换时使用DATETIME。',

  'mysql.faq.q4': '如何在MySQL中处理时区？',
  'mysql.faq.a4': '使用TIMESTAMP类型以UTC存储所有时间戳，然后在显示时转换为本地时区。',

  // Python时间戳页面
  'python.mainTitle': 'Python时间戳完整指南',
  'python.mainTitleSEO': 'Python时间戳教程 - datetime、time、calendar模块指南',
  'python.subtitle': '掌握Python的datetime、time和calendar模块处理时间戳',

  'python.intro': 'Python提供多个模块来处理时间戳。本综合指南涵盖time、datetime、calendar和时区处理。',

  // 获取当前时间戳
  'python.getCurrentTitle': '获取当前Unix时间戳',
  'python.getCurrentDesc': 'Python中获取当前Unix时间戳的多种方法',
  'python.method1': '使用 time.time() - 返回浮点数',
  'python.method2': '使用 datetime.now() - 返回整数',
  'python.method3': '使用 calendar 模块',

  // 将时间戳转换为日期时间
  'python.toDatetimeTitle': '将时间戳转换为日期时间',
  'python.toDatetimeDesc': '将Unix时间戳转换为Python datetime对象',
  'python.fromTimestamp': '使用 datetime.fromtimestamp()',
  'python.formatDatetime': '格式化日期时间字符串',
  'python.timezoneAware': '时区感知的日期时间',

  // 将日期时间转换为时间戳
  'python.toTimestampTitle': '将日期时间转换为时间戳',
  'python.toTimestampDesc': '将Python datetime对象转换为Unix时间戳',
  'python.usingTimestamp': '使用 .timestamp() 方法',
  'python.usingMktime': '使用 time.mktime()',

  // 时区处理
  'python.timezoneTitle': '时区处理',
  'python.timezoneDesc': '使用pytz和zoneinfo处理时区',
  'python.pytzExample': '使用pytz库',
  'python.zoneinfoExample': '使用zoneinfo（Python 3.9+）',

  // 常见模式
  'python.patternsTitle': '常见模式和用例',
  'python.pattern1.title': '时间戳运算',
  'python.pattern1.desc': '对时间戳进行加减运算',

  'python.pattern2.title': '比较时间戳',
  'python.pattern2.desc': '比较两个时间戳以查找时间差',

  'python.pattern3.title': '舍入时间戳',
  'python.pattern3.desc': '将时间戳舍入到最近的天/小时/分钟',

  'python.pattern4.title': '解析字符串为时间戳',
  'python.pattern4.desc': '将日期字符串转换为时间戳',

  // JavaScript时间戳页面
  'javascript.mainTitle': 'JavaScript时间戳完整指南',
  'javascript.mainTitleSEO': 'JavaScript时间戳教程 - Date对象和方法指南',
  'javascript.subtitle': '掌握JavaScript Date对象、时间戳方法和时区处理',

  'javascript.intro': 'JavaScript提供Date对象来处理时间戳。本指南涵盖从基本方法到高级时区处理的所有内容。',

  // 获取当前时间戳
  'javascript.getCurrentTitle': '获取当前Unix时间戳',
  'javascript.getCurrentDesc': 'JavaScript中获取当前时间戳的多种方法',
  'javascript.dateNow': '使用 Date.now() - 最高效',
  'javascript.getTime': '使用 new Date().getTime()',
  'javascript.valueOf': '使用 valueOf() 方法',
  'javascript.unaryPlus': '使用一元+运算符',

  // 将时间戳转换为日期
  'javascript.toDateTitle': '将时间戳转换为日期',
  'javascript.toDateDesc': '将Unix时间戳转换为JavaScript Date对象',
  'javascript.newDate': '从时间戳创建Date',
  'javascript.formatDate': '格式化日期字符串',
  'javascript.toLocaleString': '使用 toLocaleString() 进行格式化',

  // 将日期转换为时间戳
  'javascript.toTimestampTitle': '将日期转换为时间戳',
  'javascript.toTimestampDesc': '将JavaScript Date转换为Unix时间戳',
  'javascript.parseDate': '解析日期字符串为时间戳',
  'javascript.dateComponents': '从组件创建时间戳',

  // 日期库
  'javascript.librariesTitle': '流行的日期库',
  'javascript.momentJs': 'Moment.js（传统）',
  'javascript.dayJs': 'Day.js（轻量级）',
  'javascript.dateFns': 'date-fns（现代）',
  'javascript.luxon': 'Luxon（时区感知）',

  // Java & PHP - 类似结构
  'java.mainTitle': 'Java时间戳完整指南',
  'java.mainTitleSEO': 'Java时间戳教程 - Date、Calendar、Instant指南',
  'java.subtitle': '掌握Java的Date、Calendar、Instant和LocalDateTime处理时间戳',
  'java.intro': 'Java提供多个API来处理时间戳。本指南涵盖传统的Date/Calendar类和现代的java.time API（Java 8+）。',

  // 获取当前时间戳
  'java.getCurrentTitle': '获取当前Unix时间戳',
  'java.getCurrentDesc': 'Java中获取当前时间戳的多种方法',
  'java.method1': '使用 System.currentTimeMillis() - 最快',
  'java.method2': '使用 Instant.now() - 现代方式（Java 8+）',
  'java.method3': '使用 Date 类 - 传统方式',

  // 将时间戳转换为日期
  'java.toDateTitle': '将时间戳转换为日期',
  'java.toDateDesc': '将Unix时间戳转换为Java Date/Instant/LocalDateTime',
  'java.fromTimestamp': '使用 Instant.ofEpochSecond()',
  'java.toLocalDateTime': '转换为 LocalDateTime',
  'java.formatDate': '使用 DateTimeFormatter 格式化',

  // 将日期转换为时间戳
  'java.toTimestampTitle': '将日期转换为时间戳',
  'java.toTimestampDesc': '将Java Date/Instant/LocalDateTime转换为Unix时间戳',
  'java.dateToTimestamp': '使用 Date.getTime()',
  'java.instantToTimestamp': '使用 Instant 方法',

  // 时区处理
  'java.timezoneTitle': '时区处理',
  'java.timezoneDesc': '使用ZoneId和ZonedDateTime处理时区',
  'java.zoneIdExample': '使用 ZoneId',
  'java.zonedDateTimeExample': '使用 ZonedDateTime',

  // 常见模式
  'java.patternsTitle': 'Java时间戳常见模式',
  'java.pattern1.title': '日期运算',
  'java.pattern1.desc': '使用Duration和Period进行加减运算',
  'java.pattern2.title': '解析日期字符串',
  'java.pattern2.desc': '使用DateTimeFormatter解析字符串为时间戳',
  'java.pattern3.title': '比较时间戳',
  'java.pattern3.desc': '比较日期并计算差值',

  'php.mainTitle': 'PHP时间戳完整指南',
  'php.mainTitleSEO': 'PHP时间戳教程 - time()、strtotime()、DateTime指南',
  'php.subtitle': '掌握PHP的time()、date()、strtotime()和DateTime类处理时间戳',
  'php.intro': 'PHP提供强大的函数来处理时间戳。本指南涵盖过程式函数和面向对象的DateTime类。',

  // 获取当前时间戳
  'php.getCurrentTitle': '获取当前Unix时间戳',
  'php.getCurrentDesc': 'PHP中获取当前时间戳的多种方法',
  'php.method1': '使用 time() - 最常用',
  'php.method2': '使用 microtime() - 带微秒',
  'php.method3': '使用 DateTime 类',

  // 将时间戳转换为日期
  'php.toDateTitle': '将时间戳转换为日期',
  'php.toDateDesc': '将Unix时间戳转换为格式化的日期字符串',
  'php.dateFunction': '使用 date() 函数',
  'php.dateTimeClass': '使用 DateTime 类',
  'php.formatDate': '自定义日期格式',

  // 将日期转换为时间戳
  'php.toTimestampTitle': '将日期转换为时间戳',
  'php.toTimestampDesc': '将日期字符串转换为Unix时间戳',
  'php.strtotime': '使用 strtotime() - 解析英文文本',
  'php.dateTimeToTimestamp': '使用 DateTime::getTimestamp()',

  // 时区处理
  'php.timezoneTitle': '时区处理',
  'php.timezoneDesc': '使用DateTimeZone处理时区',
  'php.setTimezone': '设置默认时区',
  'php.dateTimeZone': '使用 DateTimeZone 类',

  // 常见模式
  'php.patternsTitle': 'PHP时间戳常见模式',
  'php.pattern1.title': '日期运算',
  'php.pattern1.desc': '使用strtotime()或DateInterval进行加减运算',
  'php.pattern2.title': '解析相对日期',
  'php.pattern2.desc': '解析"next Monday"、"last week"等',
  'php.pattern3.title': '比较时间戳',
  'php.pattern3.desc': '比较日期并计算差值',

  // SQL时间戳页面（通用 - MySQL, PostgreSQL, Oracle, SQL Server）
  'sql.mainTitle': 'SQL时间戳完整指南',
  'sql.mainTitleSEO': 'SQL时间戳教程 - MySQL、PostgreSQL、Oracle、SQL Server',
  'sql.subtitle': '掌握MySQL、PostgreSQL、Oracle和SQL Server数据库的时间戳处理',

  'sql.intro': '不同SQL数据库处理Unix时间戳的方式各不相同。本综合指南涵盖MySQL、PostgreSQL、Oracle和SQL Server的时间戳函数，帮助您在Unix时间戳和数据库日期时间格式之间转换。',

  // 数据库选择
  'sql.selectDatabase': '选择您的数据库',

  // 对比
  'sql.comparisonTitle': '快速参考：各数据库时间戳函数对比',

  // 常见用例
  'sql.commonUseCases': '所有数据库的常见使用场景',
  'sql.useCase1.title': '存储创建时间戳',
  'sql.useCase1.desc': '使用默认时间戳值自动跟踪记录创建时间',
  'sql.useCase2.title': '跟踪最后更新时间',
  'sql.useCase2.desc': '在记录更改时自动更新修改时间戳',
  'sql.useCase3.title': '按日期范围筛选',
  'sql.useCase3.desc': '查询特定时间戳范围内的记录，用于分析和报告',
  'sql.useCase4.title': '按时间段分组',
  'sql.useCase4.desc': '使用时间戳函数按小时、天、月或年聚合数据',

  // 最佳实践
  'sql.bestPractice1': '始终以UTC存储时间戳，避免时区混淆',
  'sql.bestPractice2': '为WHERE子句中频繁使用的时间戳列创建索引以提高性能',
  'sql.bestPractice3': '尽可能使用数据库原生函数而不是在应用程序代码中转换',
  'sql.bestPractice4': '使用32位整数时间戳时要注意2038年问题',
  'sql.bestPractice5': '使用BIGINT存储毫秒时间戳以避免溢出问题',
};
